module.exports = __webpack_public_path__ + "assets/reset.db5d25fa.svg";